import { render, staticRenderFns } from "./AddProject.vue?vue&type=template&id=4db56d92"
import script from "./AddProject.vue?vue&type=script&lang=js"
export * from "./AddProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports